module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kerry Dolan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("KERRY DOLAN is a Philadelphia-based writer. A finalist for the New American Fiction Prize and the Tartt First Fiction Award, her work has appeared in "), _c('I', [_vm._v("Quarterly West")]), _vm._v(", "), _c('I', [_vm._v("Greensboro Review")]), _vm._v(", "), _c('I', [_vm._v("Robert Olen Butler Prize Stories,")]), _vm._v(" and elsewhere. Dolan has received fellowships from MacDowell, the Ucross Foundation, the Millay Colony, and the Virginia Center for the Creative Arts.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RFIA3v/tc-custom/9781613769140.jpg?1705766094557",
      "alt": "This image is the cover for the book Safe Places"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Safe Places\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Exploring the vagaries of life, human connection, and desire, the twelve stories of "), _c('i', [_vm._v("Safe Places")]), _vm._v(" navigate the fault lines of existence. Shifting from New York and Chicago to the American West and the Australian outback, Kerry Dolan’s characters move through an uncertain and unpredictable world, confronting situations that are alternately menacing, tragic, and funny. An aspiring anthropologist falls under the sway of her fortuneteller. An American tourist catches opal fever in an Australian mining town and binds herself to a man she despises. Two hitchhiking teens take a ride with a mysterious stranger, while an unstable graduate student stalks the object of his affections across Berkeley. Assured and distinctive, the voice-driven stories of this debut collection capture the restless heart of characters in a state of flux, as they try—and frequently fail—to move beyond chance and circumstance.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Massachusetts Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0